import { IIndicatorsProps } from "./types";

export function Indicators({REP_BUILD_DATA,infocusID,batches, VGV_RANGE_FIRST_AMOUNT_RAW,VGV_RANGE_LAST_AMOUNT_RAW}: IIndicatorsProps) {

    return (
        <div data-infocusID={infocusID === 10}
            className="md:absolute
                print:!relative
                print:!left-0
                border-[1px] border-r-[#000]
                last-of-type:border-none
                opacity-100 -left-[100%]
                data-[inFocusID=true]:opacity-0
                data-[inFocusID=true]:left-0
                transition-all duration-[0.38s]
                w-full h-screen flex flex-col justify-between gap-4 p-8 bg-white
                page-break
            "
        >
            <div className="w-[60%] flex flex-col justify-between gap-16 py-16">
                <span className="w-full h-auto flex flex-col gap-4">
                    <span className="text-5xl text-black">Indicadores </span>
                    <span className="text-xl text-gray-500">
                       Imóvel performado com valor médio de venda da casa {
                                Intl.NumberFormat('pt-BR', {
                                    style: 'currency',
                                    currency: 'BRL',
                                })
                                .format(REP_BUILD_DATA?.houseAmount || 0)
                            } {" "}
                            e área ideal construída na faixa de
                        {" "}
                        {REP_BUILD_DATA?.idealAreaBuild}m²
                    </span>
                </span>
            </div>
            <span className="w-full flex-1 flex flex-col gap-0">
                <span className="w-full h-12 flex flex-row flex-nowrap items-center justify-center">
                    <span className="flex flex-nowrap items-center justify-center p-6 bg-[#cde9e1] flex-1 font-semibold first-of-type:border-l-[2px]  border-b-[2px] border-t-[2px] border-r-[2px] border-black">Módulo</span>
                    <span className="flex flex-nowrap items-center justify-center p-6 bg-[#cde9e1] flex-1 font-semibold border-t-[2px] border-b-[2px] border-r-[2px] border-black">Área (m²)</span>
                    <span className="flex flex-nowrap items-center justify-center p-6 bg-[#cde9e1] flex-1 font-semibold border-t-[2px] border-b-[2px] border-r-[2px] border-black">Valor total</span>
                    <span className="flex flex-nowrap items-center justify-center p-6 bg-[#cde9e1] flex-1 font-semibold border-t-[2px] border-b-[2px] border-r-[2px] border-black">R$/m²</span>
                    <span className="flex flex-nowrap items-center justify-center p-6 bg-[#cde9e1] flex-1 font-semibold border-t-[2px] border-b-[2px] border-r-[2px] border-black">Anúncio</span>
                </span>
                <span className="w-full flex-1 flex flex-col mt-[14px]">
                    {
                        batches.map((batche, index) => (
                            <span key={batche.id} data-idealbatch={batche.area <= (REP_BUILD_DATA?.idealArea || 0) && (batche.amount >= VGV_RANGE_FIRST_AMOUNT_RAW || batche.amount <= VGV_RANGE_LAST_AMOUNT_RAW)} className="w-full h-auto flex flex-row flex-nowrap data-[idealbatch=true]:bg-[#9cd3c3] hover:bg-[#9cd3c3]">
                                <span data-first={index === 0} className="max-w-[50%] z-[999] flex flex-nowrap items-center justify-center p-6 flex-1 font-semibold data-[first=true]:border-t-[0px] first-of-type:border-l-[2px]  border-b-[2px] border-t-[2px] border-r-[2px] border-black">
                                    {
                                        batche.name
                                    }
                                </span>
                                <span data-first={index === 0} className="max-w-[50%] flex flex-nowrap items-center justify-center p-6 flex-1 font-semibold data-[first=true]:border-t-[0px] first-of-type:border-l-[2px]  border-b-[2px] border-t-[2px] border-r-[2px] border-black">
                                    {
                                        batche.area
                                    }m²
                                </span>
                                <span data-first={index === 0} className="max-w-[50%] flex flex-nowrap items-center justify-center p-6 flex-1 font-semibold data-[first=true]:border-t-[0px] first-of-type:border-l-[2px]  border-b-[2px] border-t-[2px] border-r-[2px] border-black">
                                    {
                                        Intl.NumberFormat("pt-BR", {
                                            style: 'currency',
                                            currency: 'BRL'
                                        }).format(batche.amount)
                                    }
                                </span>
                                <span data-first={index === 0} className="max-w-[50%] flex flex-nowrap items-center justify-center p-6 flex-1 font-semibold data-[first=true]:border-t-[0px] first-of-type:border-l-[2px]  border-b-[2px] border-t-[2px] border-r-[2px] border-black">
                                    {
                                        Intl.NumberFormat("pt-BR", {
                                            style: 'currency',
                                            currency: 'BRL'
                                        }).format(batche.square_meter)
                                    }/m²
                                </span>
                                <span data-first={index === 0} className="z-[999] cursor-not-allowed max-w-[50%] flex flex-nowrap items-center justify-center p-6 flex-1 font-semibold data-[first=true]:border-t-[0px] first-of-type:border-l-[2px]  border-b-[2px] border-t-[2px] border-r-[2px] border-black">
                                    Não disponivel
                                </span>
                            </span>
                        ))
                    }
                </span>
            </span>
        </div>
    )
}
